interface Noop {
  (): void;
}

export const noop: Noop = () => void 0;
